import { render, staticRenderFns } from "./GroupSetup.vue?vue&type=template&id=2c2ce0da&scoped=true"
import script from "./GroupSetup.vue?vue&type=script&lang=js"
export * from "./GroupSetup.vue?vue&type=script&lang=js"
import style0 from "./GroupSetup.vue?vue&type=style&index=0&id=2c2ce0da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ce0da",
  null
  
)

export default component.exports